/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { TrackResizeContainer } from '../PRIVATE_TrackResizeContainer';
import { Flex } from '../UNSAFE_Flex';
import { classNames } from '../utils/UNSAFE_classNames';
import { zoomControlsLayoutStyles } from './themes/TimeComponentStyles.css';
import { TimeComponentZoomInControl } from './TimeComponentZoomInControl';
import { TimeComponentZoomOutControl } from './TimeComponentZoomOutControl';
import type {
  OnTimeComponentViewportChange,
  TimeComponentZoomParameters
} from './TimeComponent.types';

type Props = {
  position?: 'topStart' | 'topEnd' | 'bottomStart' | 'bottomEnd';
  zoomParameters: TimeComponentZoomParameters;
  onViewportChange?: OnTimeComponentViewportChange;
};

export function TimeComponentZoomControls({
  position = 'topEnd',
  zoomParameters,
  onViewportChange
}: Props) {
  return (
    <TrackResizeContainer width="100%" height="100%">
      {(width, _) => {
        const { getZoomOrderViewDurationThresholds, ...restZoomParameters } = zoomParameters;
        const zoomOrderViewDurationThresholds = getZoomOrderViewDurationThresholds(width);
        return (
          <div
            class={classNames([zoomControlsLayoutStyles.base, zoomControlsLayoutStyles[position]])}>
            <div class={zoomControlsLayoutStyles.controls}>
              <Flex direction="column" gap="2.25x">
                <TimeComponentZoomInControl
                  {...restZoomParameters}
                  zoomOrderViewDurationThresholds={zoomOrderViewDurationThresholds}
                  onViewportChange={onViewportChange}
                />
                <TimeComponentZoomOutControl
                  {...restZoomParameters}
                  zoomOrderViewDurationThresholds={zoomOrderViewDurationThresholds}
                  onViewportChange={onViewportChange}
                />
              </Flex>
            </div>
          </div>
        );
      }}
    </TrackResizeContainer>
  );
}
